import React from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

import { BasicInput } from "components";

import { ASSISTANT_QUESTION_MAX_LENGTH } from "../../constants";
import {
  AssistantComposer,
  AssistantComposerHint,
  AssistantInputField,
  AssistantInputRow,
  AssistantSendButton,
} from "./styles";
import { IAssistantPromptSectionProps } from "./types";

const AssistantPromptSection: React.FC<IAssistantPromptSectionProps> = ({
  question,
  pending,
  onQuestionChange,
  onAsk,
}) => {
  return (
    <AssistantComposer
      component="form"
      onSubmit={(event) => {
        event.preventDefault();
        if (!pending && question.trim()) onAsk();
      }}
    >
      <AssistantInputRow>
        <AssistantInputField>
          <BasicInput
            name="assistantPrompt"
            label="Ask about a task or feature…"
            variant="outlined"
            multiline
            maxRows={3}
            value={question}
            onChange={(event) => onQuestionChange(event.target.value)}
            onKeyDown={(event) => {
              if (
                event.key === "Enter" &&
                !event.shiftKey &&
                !event.nativeEvent.isComposing
              ) {
                event.preventDefault();
                if (!pending && question.trim()) onAsk();
              }
            }}
            inputProps={{
              inputProps: {
                maxLength: ASSISTANT_QUESTION_MAX_LENGTH,
                "aria-label": "Ask about a task or feature",
              },
            }}
            disabled={pending}
          />
        </AssistantInputField>
        <AssistantSendButton
          type="submit"
          fullWidth={false}
          aria-label={pending ? "Sending question" : "Send question"}
          disabled={pending || !question.trim()}
        >
          <ArrowUpwardIcon fontSize="small" />
        </AssistantSendButton>
      </AssistantInputRow>
      <AssistantComposerHint variant="subtitle9">
        Answers from your user guides
      </AssistantComposerHint>
    </AssistantComposer>
  );
};

export default AssistantPromptSection;
